<template>
  <div>
    <NuxtPage />
  </div>
</template>

<script setup lang="ts">
import { usePlatformStore } from '@/store-pinia/platform'
import { useFunBookV2Store } from '@/store-pinia/funbookV2'

definePageMeta({
  scrollToTop: true,
  name: 'FunBookBranchIdParent',
  key: route => {
    const routeName = route.name as string
    if (routeName.includes('booking-product_id')) {
      return 'FunBookV2BookingPageID'
    }
    return route.path
  },
  layout: 'default',
  async middleware(to) {
    const nuxtApp = useNuxtApp()
    const branchId = to.params.branch_id as string
    const platformStore = usePlatformStore(nuxtApp.$pinia)
    const funbookV2Store = useFunBookV2Store(nuxtApp.$pinia)
    const routeName = (to.name || '') as string

    if (routeName.includes('funbook-branch_id-real_contact')) {
      setPageLayout('real-contact')
    }
    if (routeName.includes('funbook-branch_id-booking') && !routeName.includes('funbook-branch_id-booking-product_id')) {
      setPageLayout('funbook')
    }
    if (routeName.includes('funbook-branch_id-booking') && routeName.includes('funbook-branch_id-booking-product_id')) {
      setPageLayout('booking-layout')
    }

    if (platformStore.isFunBookV2) {
      await funbookV2Store.getFunBookV2LayoutData(nuxtApp.$axios, branchId)
    }
  },
})
</script>
